import { render } from "./Tile.vue?vue&type=template&id=8fd975e2&scoped=true&ts=true"
import script from "./Tile.vue?vue&type=script&lang=ts"
export * from "./Tile.vue?vue&type=script&lang=ts"

import "./Tile.vue?vue&type=style&index=0&id=8fd975e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd975e2"]])

export default __exports__